import { render } from "./comp-model.vue?vue&type=template&id=50fd6137"
import script from "./comp-model.vue?vue&type=script&lang=js"
export * from "./comp-model.vue?vue&type=script&lang=js"

import "./comp-model.vue?vue&type=style&index=0&id=50fd6137&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__